/**
 * Build the public URL for a stored file.
 *
 * - If `imagesUrl` (CDN / image subdomain) is provided, strip the upload prefix and use it.
 * - Otherwise fall back to the API serve endpoint.
 */
export function getFileUrl(
  file: { id: number; key: string },
  imagesUrl?: string,
  apiUrl?: string,
): string {
  if (imagesUrl) {
    const keyPath = file.key.replace("./uploads/", "");
    return `${imagesUrl}/${keyPath}`;
  }
  const base = apiUrl?.replace(/\/$/, "") ?? "http://localhost:3230";
  return `${base}/v1/files/${file.id}/serve`;
}
